import { UIInputText } from "@lya-protect/lya-protect-form-library/dist/UI";
import Close from "@/assets/icons/x-lg.svg?react";
import classNames from "classnames";
import { ChangeEventHandler } from "react";
import styles from "./InputSearch.module.scss";

type InputSearchProps = {
  placeholder: string;
  hasError?: boolean;
  name: string;
  onChange?: ChangeEventHandler<HTMLInputElement>;
  value?: string;
  variant?: "small" | "full-width";
  onClear?: () => void;
};
export function InputSearch({
  placeholder,
  hasError = false,
  name,
  onChange,
  value,
  variant = "small",
  onClear
}: InputSearchProps) {
  const showClear = Boolean(onClear) && Boolean(value);
  return (
    <div
      className={classNames(styles.wrapper, styles[variant])}
    >
      <UIInputText
        value={value}
        placeholder={placeholder}
        hasError={hasError}
        name={name}
        onChange={onChange}
        className={classNames(styles.inputsearch, {
          [styles.hasClear]: showClear
        })}
      />
      {showClear && (
        <button
          type="button"
          className={styles.clearButton}
          aria-label="Effacer la recherche"
          onClick={onClear}
        >
          <Close />
        </button>
      )}
    </div>
  );
}
